/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetDayAvailability200ResponseValueInner,
  GetReservationAnticipation200Response,
  GetReservationCapacities200Response,
  GetReservationDinersLimit200Response,
  GetReservationDurations200Response,
  GetReservationLargeGroupLimit200Response,
  GetReservationLargeGroups200Response,
  GetReservationMaxReservationsPerSlot200Response,
  GetReservationSlotTime200Response,
  UpdateLocationComboRequest,
  UpsertReservationExtraTextRequest,
} from '../models/index';
import {
    GetDayAvailability200ResponseValueInnerFromJSON,
    GetDayAvailability200ResponseValueInnerToJSON,
    GetReservationAnticipation200ResponseFromJSON,
    GetReservationAnticipation200ResponseToJSON,
    GetReservationCapacities200ResponseFromJSON,
    GetReservationCapacities200ResponseToJSON,
    GetReservationDinersLimit200ResponseFromJSON,
    GetReservationDinersLimit200ResponseToJSON,
    GetReservationDurations200ResponseFromJSON,
    GetReservationDurations200ResponseToJSON,
    GetReservationLargeGroupLimit200ResponseFromJSON,
    GetReservationLargeGroupLimit200ResponseToJSON,
    GetReservationLargeGroups200ResponseFromJSON,
    GetReservationLargeGroups200ResponseToJSON,
    GetReservationMaxReservationsPerSlot200ResponseFromJSON,
    GetReservationMaxReservationsPerSlot200ResponseToJSON,
    GetReservationSlotTime200ResponseFromJSON,
    GetReservationSlotTime200ResponseToJSON,
    UpdateLocationComboRequestFromJSON,
    UpdateLocationComboRequestToJSON,
    UpsertReservationExtraTextRequestFromJSON,
    UpsertReservationExtraTextRequestToJSON,
} from '../models/index';

export interface EnableCustomPageRequest {
    updateLocationComboRequest: UpdateLocationComboRequest;
}

export interface GetDayAvailabilityRequest {
    partySize: number;
    date: string;
    ignoreReservationId?: string;
}

export interface GetMonthAvailabilityRequest {
    partySize: number;
    month: string;
    ignoreReservationId?: string;
}

export interface UpsertReservationAnticipationRequest {
    getReservationAnticipation200Response: GetReservationAnticipation200Response;
}

export interface UpsertReservationCapacitiesRequest {
    getReservationCapacities200Response?: GetReservationCapacities200Response;
}

export interface UpsertReservationDinersLimitRequest {
    getReservationDinersLimit200Response: GetReservationDinersLimit200Response;
}

export interface UpsertReservationDurationsRequest {
    getReservationDurations200Response?: GetReservationDurations200Response;
}

export interface UpsertReservationExtraTextOperationRequest {
    upsertReservationExtraTextRequest: UpsertReservationExtraTextRequest;
}

export interface UpsertReservationLargeGroupLimitRequest {
    getReservationLargeGroupLimit200Response: GetReservationLargeGroupLimit200Response;
}

export interface UpsertReservationLargeGroupsRequest {
    getReservationLargeGroups200Response: GetReservationLargeGroups200Response;
}

export interface UpsertReservationMaxReservationsPerSlotRequest {
    getReservationMaxReservationsPerSlot200Response: GetReservationMaxReservationsPerSlot200Response;
}

export interface UpsertReservationSlotTimeRequest {
    getReservationSlotTime200Response: GetReservationSlotTime200Response;
}

/**
 * 
 */
export class AvailabilityApi extends runtime.BaseAPI {

    /**
     */
    async enableCustomPageRaw(requestParameters: EnableCustomPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateLocationComboRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationComboRequest',
                'Required parameter "updateLocationComboRequest" was null or undefined when calling enableCustomPage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/custom-page/enable`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationComboRequestToJSON(requestParameters['updateLocationComboRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async enableCustomPage(requestParameters: EnableCustomPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableCustomPageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDayAvailabilityRaw(requestParameters: GetDayAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<GetDayAvailability200ResponseValueInner>; }>> {
        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getDayAvailability().'
            );
        }

        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getDayAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/calculate/day`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getDayAvailability(requestParameters: GetDayAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<GetDayAvailability200ResponseValueInner>; }> {
        const response = await this.getDayAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMonthAvailabilityRaw(requestParameters: GetMonthAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['partySize'] == null) {
            throw new runtime.RequiredError(
                'partySize',
                'Required parameter "partySize" was null or undefined when calling getMonthAvailability().'
            );
        }

        if (requestParameters['month'] == null) {
            throw new runtime.RequiredError(
                'month',
                'Required parameter "month" was null or undefined when calling getMonthAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['partySize'] != null) {
            queryParameters['partySize'] = requestParameters['partySize'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['ignoreReservationId'] != null) {
            queryParameters['ignoreReservationId'] = requestParameters['ignoreReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/calculate/month`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getMonthAvailability(requestParameters: GetMonthAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getMonthAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationAnticipationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationAnticipation200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/anticipation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationAnticipation200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationAnticipation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationAnticipation200Response> {
        const response = await this.getReservationAnticipationRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationCapacitiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationCapacities200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/capacities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationCapacities200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationCapacities(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationCapacities200Response> {
        const response = await this.getReservationCapacitiesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationDinersLimitRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationDinersLimit200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/diners-limit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationDinersLimit200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationDinersLimit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationDinersLimit200Response> {
        const response = await this.getReservationDinersLimitRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationDurationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationDurations200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/durations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationDurations200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationDurations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationDurations200Response> {
        const response = await this.getReservationDurationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationLargeGroupLimitRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationLargeGroupLimit200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/large-groups-limit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationLargeGroupLimit200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationLargeGroupLimit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationLargeGroupLimit200Response> {
        const response = await this.getReservationLargeGroupLimitRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationLargeGroupsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationLargeGroups200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/large-groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationLargeGroups200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationLargeGroups(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationLargeGroups200Response> {
        const response = await this.getReservationLargeGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationMaxReservationsPerSlotRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationMaxReservationsPerSlot200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/max-reservations-per-slot`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationMaxReservationsPerSlot200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationMaxReservationsPerSlot(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationMaxReservationsPerSlot200Response> {
        const response = await this.getReservationMaxReservationsPerSlotRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationSlotTimeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReservationSlotTime200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/availability/slot-time`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReservationSlotTime200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReservationSlotTime(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReservationSlotTime200Response> {
        const response = await this.getReservationSlotTimeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async upsertReservationAnticipationRaw(requestParameters: UpsertReservationAnticipationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationAnticipation200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationAnticipation200Response',
                'Required parameter "getReservationAnticipation200Response" was null or undefined when calling upsertReservationAnticipation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/anticipation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationAnticipation200ResponseToJSON(requestParameters['getReservationAnticipation200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationAnticipation(requestParameters: UpsertReservationAnticipationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationAnticipationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationCapacitiesRaw(requestParameters: UpsertReservationCapacitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/capacities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationCapacities200ResponseToJSON(requestParameters['getReservationCapacities200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationCapacities(requestParameters: UpsertReservationCapacitiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationCapacitiesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationDinersLimitRaw(requestParameters: UpsertReservationDinersLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationDinersLimit200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationDinersLimit200Response',
                'Required parameter "getReservationDinersLimit200Response" was null or undefined when calling upsertReservationDinersLimit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/diners-limit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationDinersLimit200ResponseToJSON(requestParameters['getReservationDinersLimit200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationDinersLimit(requestParameters: UpsertReservationDinersLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationDinersLimitRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationDurationsRaw(requestParameters: UpsertReservationDurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/durations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationDurations200ResponseToJSON(requestParameters['getReservationDurations200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationDurations(requestParameters: UpsertReservationDurationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationDurationsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationExtraTextRaw(requestParameters: UpsertReservationExtraTextOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['upsertReservationExtraTextRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertReservationExtraTextRequest',
                'Required parameter "upsertReservationExtraTextRequest" was null or undefined when calling upsertReservationExtraText().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/custom-page/extra-text`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertReservationExtraTextRequestToJSON(requestParameters['upsertReservationExtraTextRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationExtraText(requestParameters: UpsertReservationExtraTextOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationExtraTextRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationLargeGroupLimitRaw(requestParameters: UpsertReservationLargeGroupLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationLargeGroupLimit200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationLargeGroupLimit200Response',
                'Required parameter "getReservationLargeGroupLimit200Response" was null or undefined when calling upsertReservationLargeGroupLimit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/large-groups-limit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationLargeGroupLimit200ResponseToJSON(requestParameters['getReservationLargeGroupLimit200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationLargeGroupLimit(requestParameters: UpsertReservationLargeGroupLimitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationLargeGroupLimitRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationLargeGroupsRaw(requestParameters: UpsertReservationLargeGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationLargeGroups200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationLargeGroups200Response',
                'Required parameter "getReservationLargeGroups200Response" was null or undefined when calling upsertReservationLargeGroups().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/large-groups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationLargeGroups200ResponseToJSON(requestParameters['getReservationLargeGroups200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationLargeGroups(requestParameters: UpsertReservationLargeGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationLargeGroupsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationMaxReservationsPerSlotRaw(requestParameters: UpsertReservationMaxReservationsPerSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationMaxReservationsPerSlot200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationMaxReservationsPerSlot200Response',
                'Required parameter "getReservationMaxReservationsPerSlot200Response" was null or undefined when calling upsertReservationMaxReservationsPerSlot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/max-reservations-per-slot`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationMaxReservationsPerSlot200ResponseToJSON(requestParameters['getReservationMaxReservationsPerSlot200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationMaxReservationsPerSlot(requestParameters: UpsertReservationMaxReservationsPerSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationMaxReservationsPerSlotRaw(requestParameters, initOverrides);
    }

    /**
     */
    async upsertReservationSlotTimeRaw(requestParameters: UpsertReservationSlotTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getReservationSlotTime200Response'] == null) {
            throw new runtime.RequiredError(
                'getReservationSlotTime200Response',
                'Required parameter "getReservationSlotTime200Response" was null or undefined when calling upsertReservationSlotTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/availability/slot-time`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReservationSlotTime200ResponseToJSON(requestParameters['getReservationSlotTime200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationSlotTime(requestParameters: UpsertReservationSlotTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationSlotTimeRaw(requestParameters, initOverrides);
    }

}
